export const CQB_TIPOS = {
    Inclusao:   1,
    Extensao:   2,
    Adequacao:  3,
    Cancelamento:   4,
}
